const FoodPansDropdown = ({
  setSelectedFoodPanSize,
  setSelectedDepth,
  containers,
  depthList,
  selectedFoodPanSize,
  selectedDepth,
}) => {
  if (window.location.pathname === "/togo-don") return null
  return (
    <div className="form-group">
      <PanSizeDropdown
        setSelectedFoodPanSize={setSelectedFoodPanSize}
        containers={containers}
        selectedFoodPanSize={selectedFoodPanSize}
      />
      <PanDepthDropdown
        depthList={depthList}
        selectedFoodPanSize={selectedFoodPanSize}
        setSelectedDepth={setSelectedDepth}
        selectedDepth={selectedDepth}
      />
    </div>
  )
}

const PanSizeDropdown = ({
  setSelectedFoodPanSize,
  containers,
  selectedFoodPanSize,
}) => {
  const descriptionFor = (container) => {
    const descriptionStrings = {
      "1/1": "Full Size Pan",
      "1/2": "Half Size Pan",
      "1/2L": "Half Size Long Pan",
      "1/3": "One Third Size Pan",
      "1/4": "Quarter Size Pan",
      "1/5": "One Fifth Size Pan",
      "1/6": "One Sixth Size Pan",
      "1/7": "One Seventh Size Pan",
      "1/8": "One Eighth Size Pan",
      "1/9": "One Ninth Size Pan",
    }

    return `${container.size} ${descriptionStrings[container.size]}`
  }

  const descriptions = [
    ...new Set(containers?.map((container) => descriptionFor(container))),
  ]

  return (
    <div className="col-sm-6 row">
      <select
        className="form-control"
        onChange={setSelectedFoodPanSize}
        value={selectedFoodPanSize || ""}
      >
        <option value="Reset">Food Pan Size</option>
        {descriptions?.map((description) => (
          <option key={description} value={description}>
            {description}
          </option>
        ))}
      </select>
    </div>
  )
}

const PanDepthDropdown = ({
  depthList,
  selectedFoodPanSize,
  setSelectedDepth,
  selectedDepth,
}) => {
  const disabled = selectedFoodPanSize === "" || selectedFoodPanSize === "Reset"
  return (
    <div className="col-sm-6">
      <select
        className="form-control"
        disabled={disabled}
        onChange={setSelectedDepth}
        value={selectedDepth}
      >
        <option value="Reset">Food Pan Depth</option>
        {depthList?.map((depth) => (
          <option key={depth} value={depth}>
            {depth}"
          </option>
        ))}
      </select>
    </div>
  )
}

export default FoodPansDropdown
